import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  drafts: localStorage.getItem('@innovationbrindes-crm/drafts-v1') ? JSON.parse(localStorage.getItem('@innovationbrindes-crm/drafts-v1')) : [],
  showDrafts: false,
}

const draftsSlice = createSlice({
  name: '@innovationbrindes-crm/drafts-v1',
  initialState,
  reducers: {
    addDraft: (state, action) => {
      state.drafts.push(action.payload)
      localStorage.setItem('@innovationbrindes-crm/drafts-v1', JSON.stringify(state.drafts))
    },
    clearDrafts: (state) => {
      state.drafts = []
      localStorage.removeItem('@innovationbrindes-crm/drafts-v1')
    },
    deleteDraft: (state, action) => {
      state.drafts = state.drafts.filter((draft) => draft.title !== action.payload)
      localStorage.setItem('@innovationbrindes-crm/drafts-v1', JSON.stringify(state.drafts))
    },
    updateDraft: (state, action) => {
      state.drafts = state.drafts.map((draft) => {
        if (draft.title === action.payload.title) {
          return action.payload
        }
        return draft
      })
      localStorage.setItem('@innovationbrindes-crm/drafts-v1', JSON.stringify(state.drafts))
    },
    toggleShowDrafts: (state) => {
      state.showDrafts = !state.showDrafts
    },
  },
})

export const { addDraft, clearDrafts, toggleShowDrafts, deleteDraft, updateDraft } = draftsSlice.actions
export const selectDrafts = (state) => state.drafts
export default draftsSlice.reducer
